import { RouteRecordRaw } from "vue-router"
import { CheckoutRouteNameEnum } from "@/shared/enums/routes/checkout.enum.ts"

export const checkoutRoutes: RouteRecordRaw[] = [
	{
		path: "/checkout/:client_secret",
		name: CheckoutRouteNameEnum.main,
		component: () => import("@/pages/checkout/CheckoutPage.vue"),
		meta: {
			title: CheckoutRouteNameEnum.main,
			layout: "MainLayout",
			authRequired: true,
			allowedRoles: ["ADVERTISER_COMPANY", "ADS_AGENCY"] as string[]
		}
	},
	{
		path: "/checkout/success",
		name: CheckoutRouteNameEnum.success,
		component: () => import("@/pages/checkout/CheckoutSuccessPage.vue"),
		meta: {
			title: CheckoutRouteNameEnum.success,
			layout: "MainLayout",
			authRequired: true,
			allowedRoles: ["ADVERTISER_COMPANY", "ADS_AGENCY"] as string[]
		}
	},
	{
		path: "/checkout/error",
		name: CheckoutRouteNameEnum.error,
		component: () => import("@/pages/checkout/CheckoutErrorPage.vue"),
		meta: {
			title: CheckoutRouteNameEnum.error,
			layout: "MainLayout",
			authRequired: true,
			allowedRoles: ["ADVERTISER_COMPANY", "ADS_AGENCY"] as string[]
		}
	},
	{
		path: "/stripe-account",
		name: CheckoutRouteNameEnum.stripeAccount,
		component: () => import("@/pages/checkout/StripeLinkRefreshPage.vue"),
		meta: {
			title: CheckoutRouteNameEnum.stripeAccount,
			authRequired: true,
			allowedRoles: ["SCREEN_OWNER"] as string[]
		}
	},
	{
		path: "/contract/:campaign_id",
		name: CheckoutRouteNameEnum.contract,
		component: () => import("@/pages/checkout/Contract.vue"),
		meta: {
			title: CheckoutRouteNameEnum.contract,
			authRequired: true,
			allowedRoles: ["ADVERTISER_COMPANY", "ADS_AGENCY"] as string[]
		}
	}
]
